module.exports = __webpack_public_path__ + "static/img/817_phase_function_Paper_PointsHejduk_Prediction.a8dd78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/817_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2hUp
// module chunks = 0